import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
  Card,
  CardContent,
  Paper
} from "@mui/material";
import { settingApi } from "../../api/api";

const PropertySaleShare = () => {
  const [referrer, setReferrer] = useState("");
  const [parent, setParent] = useState("");
  const [grandparent, setGrandParent] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [propertyErrors,setPropertyErrors]=useState({});
  const [shareData, setShareData] = useState(null);
  const valid=()=>{
    let isValid = true;
    const errors={};
    // if(!grandparent || grandparent<=0){
    //   errors.grandparent = "Please enter a valid percentage";
    //   isValid=false;
    // }
    if(!parent || parent<=0){
      errors.parent = "Please enter a valid percentage";
    }
    if(!referrer || referrer<=0){
      errors.referrer = 'Please enter a valid percentage';
      isValid=false;
    }
    setPropertyErrors(errors);
    return isValid;
  }
  useEffect(() => {
    const fetchShares = async () => {
      try {
        const shareres = await settingApi.getShares();
        setShareData(shareres.data[0]);
      } catch (error) {
        console.error("Failed to fetch shares:", error);
      }
    };

    fetchShares();
  }, []);

  const handleSubmit = async () => {
    if(!valid()) return;
    try {
      const response = await settingApi.addPropertyShare({
        referrer: referrer,
        parent: parent,
        grandparent: grandparent,
      });
      
      setSnackbar({
        open: true,
        message: "Share percentages submitted successfully!",
        severity: "success",
      });
    } catch (err) {
     
      setSnackbar({
        open: true,
        message: "Failed to submit share percentages.",
        severity: "error",
      });
    }
  };

  return (
    <Box sx={{ p: 5 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography sx={{ mb: 5, fontWeight: "bold" }} variant="h5">
          Set Share Percentage
        </Typography>

        <Card sx={{ margin: "20px auto", boxShadow: 3, mb: 5 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Current Share Percentages
            </Typography>
            <Typography variant="body1">
              <strong>Referrer:</strong> {shareData?.referrer_percent ?? 0}%
            </Typography>
            <Typography variant="body1">
              <strong>Parent:</strong> {shareData?.parent_percent ?? 0}%
            </Typography>
            
          </CardContent>
        </Card>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="Referrer Percentage"
              label="Referrer Percentage"
              type="number"
              value={referrer}
              onChange={(e) => setReferrer(e.target.value)}
              fullWidth
              variant="outlined"
              sx={{ mb: 2 }}
              error={!!propertyErrors.referrer}
              helperText={propertyErrors.referrer}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="Parent Percentage"
              label="Parent Percentage"
              type="number"
              value={parent}
              onChange={(e) => setParent(e.target.value)}
              fullWidth
              variant="outlined"
              sx={{ mb: 2 }}
              error={!!propertyErrors.parent}
              helperText={propertyErrors.parent}
            />
          </Grid>
         
          <Grid item xs={12}>
            <Button variant="contained" onClick={handleSubmit} sx={{ mr: 2 }}>
              Submit
            </Button>
            <Button variant="text">Cancel</Button>
          </Grid>
        </Grid>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PropertySaleShare;
